const GiftBox = class GiftBox extends HTMLElement {
    constructor() {
        super();
        this.variantGiftBoxMap = {};
    }

    connectedCallback() {
        const giftBoxData = this.querySelector('script');
        if (giftBoxData) {
            try {
                this.variantGiftBoxMap = JSON.parse(giftBoxData.innerHTML);
            } catch (e) {
                console.error('Failed to parse gift box data:', e);
                this.variantGiftBoxMap = [];
            }
        }
        if (this.variantGiftBoxMap.length > 0) {
            this.giftBoxVariant = this.querySelector('.jsGiftBoxVariant');
            this.addEventListener('change', this.handleChange.bind(this));
            window.addEventListener('theme:gift-box:change', this.handleGiftBoxChange.bind(this));
        }
    }

    async handleGiftBoxChange(event) {
        const variant = event.detail.variant;

        if (!variant) return;

        let giftBoxId = this.variantGiftBoxMap.find(item => Object.keys(item).toString() == variant.id.toString())
        if (giftBoxId) {
            giftBoxId = Object.values(giftBoxId)[0]
        }
        else {
            giftBoxId = null;
        }

        if (!giftBoxId) return;

        try {
            let response = await fetch(`${window.theme.routes.root_url}variants/${giftBoxId}?section_id=gift-box-variant`)
            response = await response.text();
            this.giftBoxVariant.innerHTML = response;
            this.handleChange()
        } catch (e) {
            console.error('Failed to update gift box:', e);
        }
    }

    handleChange() {
        const input = this.querySelector('[type=checkbox]');
        const inputVariant = this.querySelector('[data-gift-box-variant]');

        if (input.checked) {
            inputVariant.setAttribute('form', this.dataset.formId);
        }
        else {
            inputVariant.removeAttribute('form');
        }
    }

};
if (!customElements.get('gift-box')) {
    customElements.define('gift-box', GiftBox);
}